import { BANK_META } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getBankMeta = (payload) => {
  return apiInstance.post(BANK_META, payload);
};
